import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditOrgStructureItem from '../../components/orgStructureItems/FormAddEditOrgStructureItem';
import { useParams } from 'react-router-dom';
import { useGetOrgStructureItem } from '../../hooks/orgStructureItems/useGetOrgStructureItem';
import LoadingPage from '../../components/global/LoadingPage';

const EditOrgStructureItem = () => {
    const { id } = useParams();
    const { orgStructureItem, isLoading } = useGetOrgStructureItem(id);
    if (isLoading) return <LoadingPage />;
    return (<WrapperSection><GlobalBreadcrumbs /><FormAddEditOrgStructureItem isEdit currentData={orgStructureItem?.data} /></WrapperSection>);
};
export default EditOrgStructureItem;
